import { usePage } from "@/hooks/PageContent";
import { useTitle } from "@/hooks/UseTitle";
import * as React from "react";

export interface IPageHeadProps {
	children?: React.ReactNode;
	pageTitle: string;
	pageHead?: React.ReactNode;
}

export function PageHead(props: IPageHeadProps) {
	const page = usePage();

	useTitle(page.pageContent?.title ?? props.pageTitle);

	return !page.loading ? (
		<div>
			{<h1>{page.pageContent?.title ?? props.pageHead}</h1>}
			{!!page.pageContent?.pageCopy ? (
				<div
					className="pagebody"
					dangerouslySetInnerHTML={{ __html: page.pageContent?.pageCopy ?? "" }}></div>
			) : (
				<div className="pagebody">{props.children}</div>
			)}
		</div>
	) : (
		<></>
	);
}
